"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTHS_IN_YEAR = void 0;
exports.MONTHS_IN_YEAR = 12;
//# sourceMappingURL=constants.js.map